export default __webpack_public_path__ + "static/media/logo-shockoe.b8b8f9fa.png";